import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface DailyDataPoint {
  day: string;
  enviadas: number;
  entregues: number;
  lidas: number;
}

interface DailyChartProps {
  data: DailyDataPoint[];
}

export default function DailyChart({ data }: DailyChartProps) {
  const hasData = data.length > 0 && data.some((d) => d.enviadas > 0 || d.entregues > 0 || d.lidas > 0);

  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-heading font-semibold text-foreground-900 dark:text-foreground-100">Desempenho Diário</h3>
        <span className="text-xs text-foreground-400 bg-background-100 dark:bg-background-200 px-2 py-1 rounded-md">Últimos 7 dias</span>
      </div>

      {!hasData ? (
        <div className="h-[260px] flex flex-col items-center justify-center text-foreground-400">
          <i className="ri-bar-chart-line text-4xl mb-3" />
          <p className="text-sm font-medium">Sem dados ainda</p>
          <p className="text-xs mt-1">Os dados de envios diários aparecerão aqui após suas primeiras campanhas.</p>
        </div>
      ) : (
        <div className="h-[260px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} barGap={2} barCategoryGap="20%">
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-200))" vertical={false} />
              <XAxis dataKey="day" tick={{ fontSize: 12, fill: 'oklch(var(--foreground-500))' }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: 'oklch(var(--foreground-400))' }} axisLine={false} tickLine={false} tickFormatter={(v: number) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v.toString())} />
              <Tooltip
                contentStyle={{
                  background: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: 'oklch(var(--foreground-900))',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                }}
                formatter={(value: number) => [value.toLocaleString('pt-BR'), '']}
              />
              <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
              <Bar dataKey="enviadas" name="Enviadas" fill="oklch(var(--primary-500))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="entregues" name="Entregues" fill="oklch(var(--accent-500))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="lidas" name="Lidas" fill="oklch(var(--secondary-500))" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}